export const animalNames = [
  "Mouse",
  "Rabbit",
  "Kiwi",
  "Elephant",
  "Giraffe",
  "Rhino",
  "Hippo",
  "Horse",
  "Gazelle",
  "Bat",
  "Cat",
  "Dog",
  "Wolf",
  "Fox",
  "Bear",
  "Ostrich",
  "Sparrow",
  "Hawk",
  "Eagle",
  "Musk Ox",
  "Robin",
  "Duck",
  "Goose",
  "Kangaroo",
  "Iguana",
  "Skink",
  "Grasshopper",
  "Ant",
  "Lark",
  "Swallow",
  "Finch",
  "Thrush",
  "Woodpecker",
  "Gerbil",
  "Hamster",
  "Deer",
  "Sheep",
  "Ibex",
  "Lion",
  "Tiger",
  "Leopard",
  "Ocelot",
  "Gecko",
  "Roadrunner",
  "Coyote",
  "Aardvark",
  "Elk",
  "Kingfisher",
  "Heron",
  "Hamster",
  "Ibis",
  "Stork",
  "Gerenuk",
  "Coati",
  "Monkey",
  "Gorilla",
  "Orangutan",
  "Chimpanzee",
  "Lemur",
  "Baboon",
  "Zebra",
  "Donkey",
  "Kiang",
  "Onager",
  "Cheetah",
  "Shrew",
  "Vole",
  "Anteater",
  "Tapir",
  "Sloth",
  "Toucan",
  "Parrot",
  "Cobra",
  "Kingsnake",
  "Jerboa",
  "Mink",
  "Stoat",
  "Otter",
  "Ferret",
  "Weasel",
  "Sugar Glider",
  "Flying Squirrel",
  "Flying Fox",
  "Squirrel",
  "Fennec Fox",
  "Pronghorn",
  "Puma",
  "Trout",
  "Salmon",
  "Guppy",
  "Shark",
  "Eel",
  "Squid",
  "Octopus",
  "Cuttlefish",
  "Sea Bass",
  "Electric Eel",
  "Sunfish",
  "Chevrotain",
  "Cassowary",
  "Whale",
  "Dolphin",
  "Seal",
  "Turtle",
];
